import React from 'react';
import { connect } from 'react-redux';
import CompareCartHeader from './CompareCartHeader'
import { InHomeUtils } from './../../util/inhomeUtils'; //
import { ModalTitle, ModalBody, ModalFooter } from '@vds/modals';
import { Title, Micro } from '@vds/typography';
import { Line } from '@vds/lines';
import { TitleLockup } from '@vds/type-lockups';
import NewCompareCartModal from './newCompareCartModal';
// import {profileCart,newCart} from './test'

class CompareCartData extends React.PureComponent {
    constructor(props) {
        super(props);
        this.isReskin = this.props?.buildProductState.isReskin && this.props?.lqState && this.props?.lqState?.runtimeKey && this.props?.lqState?.runtimeKey?.EnableReskin === 'Y';
    }

    render() {
        let compareCartHeader = '';
        let buildProductState = this.props?.buildProductState;

        let cartHeaderInfo = [
            { header: 'serviceHeaders', profileHeaderNames: getCartHeader(this.props?.profileCart, "profileType"), cartHeaderNames: getCartHeader(this.props?.newCart, "newType"), profileCartInfo: getData(this.props?.profileCart, 'serviceHeaders', "profileType"), newCartInfo: getData(this.props?.newCart, 'serviceHeaders', "newType"), profileHeaderPrice: getCartPrice(this.props?.profileCart, "profileType"), cartHeaderPrice: getCartPrice(this.props?.newCart, "newType") },
            { header: 'equipments', profileHeaderNames: "Equipment", cartHeaderNames: 'Equipment', profileCartInfo: getData(this.props?.profileCart, 'equipments'), newCartInfo: getData(this.props?.newCart, 'equipments') },
            // { header: 'perks', profileHeaderNames: "Perks", cartHeaderNames: 'Perks', profileCartInfo: getData(profileCart, 'perks'), newCartInfo: getData(newCart, 'perks') },
            { header: 'perks', profileHeaderNames: "Perks", cartHeaderNames: 'Perks', profileCartInfo: getData(this.props?.profileCart, 'perks'), newCartInfo: getData(this.props?.newCart, 'perks') },
            { header: 'internet', profileHeaderNames: "Internet", cartHeaderNames: 'Internet', profileCartInfo: getData(this.props?.profileCart, 'internet'), newCartInfo: getData(this.props?.newCart, 'internet') },
            { header: 'channel', profileHeaderNames: "TV", cartHeaderNames: 'TV', profileCartInfo: getData(this.props?.profileCart, 'channel'), newCartInfo: getData(this.props?.newCart, 'channel') },
            // { header: 'intrnlChannel', profileHeaderNames: "TV", cartHeaderNames: 'TV', profileCartInfo: getData(this.props?.profileCart, 'intrnlChannel'), newCartInfo: getData(this.props?.newCart, 'intrnlChannel') },
            { header: 'listing', profileHeaderNames: "Phone", cartHeaderNames: 'Phone', profileCartInfo: getData(this.props?.profileCart, 'listing'), newCartInfo: getData(this.props?.newCart, 'listing') },
            { header: 'oneTimeCharge', profileHeaderNames: "One Time Charges", cartHeaderNames: 'One Time Charges', profileCartInfo: getData(this.props?.profileCart, 'oneTimeCharge'), newCartInfo: getData(this.props?.newCart, 'oneTimeCharge') }
        ]

        compareCartHeader = cartHeaderInfo.map((header, index) => (
            (header.profileCartInfo.length > 0 || header.newCartInfo.length > 0)?
                <CompareCartHeader profileHeaderName={header.profileHeaderNames} cartHeaderName={header.cartHeaderNames} profileCartValue={header.profileCartInfo} newCartValue={header.newCartInfo} profileHeaderPrice={header.profileHeaderPrice} cartHeaderPrice={header.cartHeaderPrice} /> :
                ""  
        ));

        function getCartHeader(cartObj, cartType) {
            let displayName = '';
            if (cartType === "profileType" || cartType === "newType") {
                displayName = cartObj && cartObj.cartData && cartObj.cartData.length && cartObj.cartData[0].serviceHeaders && cartObj.cartData[0].serviceHeaders.title || "";
            }
            //  displayName=(cartObj.cartData[0].serviceHeaders !== null ? cartObj.cartData[0].serviceHeaders.title : "");
            //  else if()    
            //  displayName=(cartObj.cartData[0].serviceHeaders !== null ? cartObj.cartData[0].serviceHeaders.title : "");
            return displayName;
        }

        function getCartPrice(cartObj, cartType) {
            var displayPrice = ''
            if (cartObj && cartObj.cartData && cartObj.cartData.length) {
                if (cartType === "profileType") {
                    displayPrice = cartObj.cartData[0].serviceHeaders.servicehead[0].price === "$0.00" ? cartObj.cartData[0].serviceHeaders.totalPrice : cartObj.cartData[0].serviceHeaders.servicehead[0].price
                }
                else if (cartType === "newType") {
                    displayPrice = cartObj.cartData[0].serviceHeaders.servicehead[0].price === "$0.00" ? cartObj.cartData[0].serviceHeaders.totalPrice : cartObj.cartData[0].serviceHeaders.servicehead[0].price
                }
            }
            return displayPrice;
        }

        function getData(cartObj, toFetch, cartType) {
            let response = [];
            switch (toFetch) {
                case 'serviceHeaders':
                    response = getServiceHeaders(cartObj);
                    return response;
                    break;
                case 'equipments':
                    response = getEquipment(cartObj);
                    return response;
                    break;
                case 'perks':
                    response = getPerks(cartObj);
                    return response;
                    break;
                case 'internet':
                    response = getInternet(cartObj);
                    return response;
                    break;
                case 'channel':
                    response = getChannel(cartObj);
                    return response;
                    break;
                case 'intrnlChannel':
                    response = getIntrnlChannel(cartObj);
                    return response;
                    break;
                case 'listing':
                    response = getVoice(cartObj);
                    return response;
                    break;
                case 'oneTimeCharge':
                    response = getOneTimeCharge(cartObj);
                    return response;
                    break;
                default:
                    break;
            }
        }

        function getServiceHeaders(cartObj) {
            let cartServInfo = [];
            if (cartObj && cartObj.cartData && cartObj.cartData.length && cartObj.cartData[0].serviceHeaders && cartObj.cartData[0].serviceHeaders.servicehead && cartObj.cartData[0].serviceHeaders.servicehead.length) {
                cartObj.cartData[0].serviceHeaders.servicehead.map((serviceheaditems, index) => (
                    cartServInfo.push({ 'prodName': serviceheaditems.prodName, 'price': serviceheaditems.price === "$0.00" ? serviceheaditems.totalPrice : serviceheaditems.price })
                ))
            }

            if (cartObj && cartObj.cartData && cartObj.cartData.length && cartObj.cartData[0].streamService && cartObj.cartData[0].streamService.streamServiceProds && cartObj.cartData[0].streamService.streamServiceProds.length) {
                cartObj.cartData[0].streamService.streamServiceProds.map((serviceheaditems, index) => (
                    cartServInfo.push({ 'prodName': serviceheaditems.prodName, 'price': serviceheaditems.price })
                ))
            }

            return cartServInfo;
        }

        function getEquipment(cartObj) {
            let cartEquipInfo = [];
            if (cartObj && cartObj.cartData && cartObj.cartData.length && cartObj.cartData[0].equipments && cartObj.cartData[0].equipments.equipment && cartObj.cartData[0].equipments.equipment.length) {
                // cartEquipInfo = cartObj.cartData[0].equipments.equipment.map(equipmentitems => equipmentitems.prodName );
                cartObj.cartData[0].equipments.equipment.map((equipmentitems, index) => (
                    cartEquipInfo.push({ 'prodName': equipmentitems.prodType === "DUMMYVROOM" ? equipmentitems.unitCount > 1 ? equipmentitems.unitCount + " Set-top Boxes" : equipmentitems.unitCount + " Set-top Box" : equipmentitems.prodName, 'price': equipmentitems.prodName === "Use my own router" && buildProductState !== undefined && buildProductState.customRouterName !== undefined && buildProductState.customRouterName !== "" ? "" : equipmentitems.price })
                ))
            }
            // cartEquipInfo.push(equipmentitems.prodName)

            return cartEquipInfo;
        }

        function getPerks(cartObj) {
            let cartPerkInfo = [];
            if (cartObj && cartObj.cartData && cartObj.cartData?.length && cartObj.cartData?.[0]?.perks && cartObj.cartData?.[0]?.perks?.perks && cartObj.cartData?.[0]?.perks?.perks?.length) {
                cartObj.cartData?.[0]?.perks?.perks?.map((perk, index) => (
                    cartPerkInfo.push({'prodName': perk.prodName, 'price': perk.price })
                ))
            }
            return cartPerkInfo;
        }

        function getChannel(cartObj) {
            let cartChannelInfo = [];
            let channelSectionPrice = "";
            if (cartObj && cartObj.cartData && cartObj.cartData.length && cartObj.cartData[0].channel && cartObj.cartData[0].channel.channelsProds && cartObj.cartData[0].channel.channelsProds.length) {
                if (InHomeUtils.isNotEmpty(cartObj.cartData[0].channel.channelsTotalprice) &&
                    InHomeUtils.isNotNull(cartObj.cartData[0].channel.channelsTotalprice) && cartObj.cartData[0].channel.channelsTotalprice !== undefined) {
                    channelSectionPrice = cartObj.cartData[0].channel.channelsTotalprice;
                }

                cartChannelInfo.push({ 'prodName': "Your Premiums - " + cartObj.cartData[0].channel.channelsProds.length + " Pack", 'price': channelSectionPrice })
                cartObj.cartData[0].channel.channelsProds.map((channels, index) => (
                    cartChannelInfo.push({ 'prodName': channels.prodName })
                ))
            }

            let intrnlChannelSectionPrice = "";
            let spanishChnlcount = "";
            if (cartObj && cartObj.cartData && cartObj.cartData.length && cartObj.cartData[0].intrnlChannel && cartObj.cartData[0].intrnlChannel.intrnlChannelsProds && cartObj.cartData[0].intrnlChannel.intrnlChannelsProds.length) {
                if (InHomeUtils.isNotEmpty(cartObj.cartData[0].intrnlChannel.intrnlChannelsTotalprice) &&
                    InHomeUtils.isNotNull(cartObj.cartData[0].intrnlChannel.intrnlChannelsTotalprice) && cartObj.cartData[0].intrnlChannel.intrnlChannelsTotalprice !== undefined) {
                    intrnlChannelSectionPrice = cartObj.cartData[0].intrnlChannel.intrnlChannelsTotalprice;
                }

                spanishChnlcount = cartObj.cartData[0].intrnlChannel.intrnlChannelsProds.filter(p => p.prodTypeVal && p.prodTypeVal.includes("SPANISH"));

                if(spanishChnlcount.length > 0){
                    cartChannelInfo.push({ 'prodName': "Your Spanish - " + spanishChnlcount.length + " Pack", 'price': intrnlChannelSectionPrice })

                    cartObj.cartData[0].intrnlChannel.intrnlChannelsProds.map((intrnlChannels, index) => {
                        if (InHomeUtils.isNotNull(intrnlChannels) && InHomeUtils.isNotNull(intrnlChannels.prodTypeVal) && intrnlChannels.prodTypeVal.includes("SPANISH")) {
                            cartChannelInfo.push({ 'prodName': intrnlChannels.prodName });
                        }
                    })
                }

                cartObj.cartData[0].intrnlChannel.intrnlChannelsProds.map((intrnlChannels, index) => {
                    if (InHomeUtils.isNotNull(intrnlChannels) && (!intrnlChannels.prodTypeVal || (InHomeUtils.isNotNull(intrnlChannels.prodTypeVal) && !intrnlChannels.prodTypeVal.includes("SPANISH")))) {
                        cartChannelInfo.push({ 'prodName': intrnlChannels.prodName, 'price': intrnlChannels.price });
                    }
                })
            }

            return cartChannelInfo;
        }

        function getIntrnlChannel(cartObj) {
            let cartIntrnlChannelInfo = [];
            let intrnlChannelSectionPrice = "";
            let spanishChnlcount = "";
            if (cartObj && cartObj.cartData && cartObj.cartData.length && cartObj.cartData[0].intrnlChannel && cartObj.cartData[0].intrnlChannel.intrnlChannelsProds && cartObj.cartData[0].intrnlChannel.intrnlChannelsProds.length) {
                if (InHomeUtils.isNotEmpty(cartObj.cartData[0].intrnlChannel.intrnlChannelsTotalprice) &&
                    InHomeUtils.isNotNull(cartObj.cartData[0].intrnlChannel.intrnlChannelsTotalprice) && cartObj.cartData[0].intrnlChannel.intrnlChannelsTotalprice !== undefined) {
                    intrnlChannelSectionPrice = cartObj.cartData[0].intrnlChannel.intrnlChannelsTotalprice;
                }

                spanishChnlcount = cartObj.cartData[0].intrnlChannel.intrnlChannelsProds.filter(p => p.prodTypeVal && p.prodTypeVal.includes("SPANISH"));

                if(spanishChnlcount.length > 0){
                    cartIntrnlChannelInfo.push({ 'prodName': "Your Spanish - " + spanishChnlcount.length + " Pack", 'price': intrnlChannelSectionPrice })

                    cartObj.cartData[0].intrnlChannel.intrnlChannelsProds.map((intrnlChannels, index) => {
                        if (InHomeUtils.isNotNull(intrnlChannels) && InHomeUtils.isNotNull(intrnlChannels.prodTypeVal) && intrnlChannels.prodTypeVal.includes("SPANISH")) {
                            cartIntrnlChannelInfo.push({ 'prodName': intrnlChannels.prodName });
                        }
                    })
                }

                cartObj.cartData[0].intrnlChannel.intrnlChannelsProds.map((intrnlChannels, index) => {
                    if (InHomeUtils.isNotNull(intrnlChannels) && (!intrnlChannels.prodTypeVal || (InHomeUtils.isNotNull(intrnlChannels.prodTypeVal) && !intrnlChannels.prodTypeVal.includes("SPANISH")))) {
                        cartIntrnlChannelInfo.push({ 'prodName': intrnlChannels.prodName, 'price': intrnlChannels.price });
                    }
                })
            }

            return cartIntrnlChannelInfo;
        }

        function getVoice(cartObj) {
            let cartVoiceInfo = [];
            if (cartObj && cartObj.cartData && cartObj.cartData.length && cartObj.cartData[0].listing && cartObj.cartData[0].listing.listingProds && cartObj.cartData[0].listing.listingProds.length) {
                cartObj.cartData[0].listing.listingProds.map((items, index) => (
                    cartVoiceInfo.push({ 'prodName': items.prodName, 'price': items.price === "Fee Waived" ? "Included" : items.price })
                ))
                // cartVoiceInfo = cartObj.cartData[0].listing.listingProds.map(items => items.prodName );
            }
            return cartVoiceInfo;
        }

        function getInternet(cartObj) {
            let cartInternetInfo = [];
            if (cartObj && cartObj.cartData && cartObj.cartData.length && cartObj.cartData[0].internet && cartObj.cartData[0].internet.internetProds && cartObj.cartData[0].internet.internetProds.length) {
                cartObj.cartData[0].internet.internetProds.map((internet, index) => (
                    cartInternetInfo.push({ 'prodName': internet.prodName, 'price': internet.price })
                ))
                //   cartInternetInfo = cartObj.cartData[0].internet.internetProds.map(internet => internet.prodName )
            }
            return cartInternetInfo;
        }

        function getOneTimeCharge(cartObj) {
            let cartOneTimeChargeInfo = [];
            if (cartObj && cartObj.cartData && cartObj.cartData.length && cartObj.cartData[0].oneTimeCharge && cartObj.cartData[0].oneTimeCharge.onetimecharge && cartObj.cartData[0].oneTimeCharge.onetimecharge.length) {
                cartObj.cartData[0].oneTimeCharge.onetimecharge.map((onetimefee, index) => (
                    cartOneTimeChargeInfo.push({ 'prodName': onetimefee.prodName, 'price': onetimefee.price })
                ))
                // const FeeWaived  = "Fee Waived";
                //      cartOneTimeChargeInfo = cartObj.cartData[0].oneTimeCharge.onetimecharge.map(onetimefee => {
                //         return onetimefee.price === FeeWaived ? "" :onetimefee.prodName 
                //      } )
            }
            return cartOneTimeChargeInfo;
        }

        const isMobile = (window.screen.width < 768) ? true : false; 

        return (
            <React.Fragment>
                {(this.props?.buildProductState?.movesstickyheaderfooter) ? 
                <div id="newCompareCart" data-modal="CompareCart" data-modal-traditional-mobile="" role="dialog" aria-hidden="false" >
                    {this.isReskin && 
                    <TitleLockup
                    data={{
                        title: {
                            size: 'titleXLarge',
                            primitive: 'h2',
                            bold: false,
                            children: 'Compare plan',
                        },
                    }} 
                    />}
                    <div className={isMobile ? "bg-gray-white-border-mobile" : "bg-gray-white-border"} >
                        <div className="row compare-header-row" tabIndex="0" aria-label="Table">
                            <div className={!this.isReskin ? "columns tiny-6 margin-bottom-medium" : "columns tiny-6 padding-vert-zero"}>
                                {!this.isReskin ? 
                                <Title size="small" viewport={InHomeUtils.getdeviceType()} color="black">
                                    Your Current Plan  &nbsp;&nbsp;&nbsp;&nbsp; {this.props?.profileCart?.cartHeader[0]?.monthlyRcPrice}/mo.
                                </Title>
                                : <Title size="small" viewport={InHomeUtils.getdeviceType()} color="black" bold={true}>
                                    Current Plan
                                </Title>
                                }
                            </div>
                            <div className={!this.isReskin ? "columns tiny-6 margin-bottom-medium" : "columns tiny-6 padding-right-zero padding-left-small "}>   
                                {!this.isReskin ? 
                                <Title size="large" viewport={InHomeUtils.getdeviceType()} primitive="h6" color="black">
                                    Your New Plan &nbsp;&nbsp;&nbsp;&nbsp; {this.props?.cart?.cartHeader[0]?.monthlyRcPrice}/mo.
                                </Title>
                                : <Title size="small" viewport={InHomeUtils.getdeviceType()} color="black" bold={true}>
                                    New Plan
                                </Title>
                                }
                            </div>
                        </div>
                    </div>
                    <ModalBody>
                        <div className="cart-tabs active" id="Month1" data-tabs-content="Month1">
                            {<NewCompareCartModal/>}
                        </div>
                    </ModalBody>
                    <div className = {isMobile ? '' : 'left'}>
                    <ModalFooter buttonData={{  
                        close: {
                            width: isMobile ? '100%' : 'auto',
                            children: 'Close',
                            use: 'primary',
                            onClick: () => {
                                document?.getElementById('close-button')?.click();
                            }
                        }
                    }} />
                    </div>
                </div>
                :
                <div className="" data-modal="CompareCart" data-modal-traditional-mobile="" role="dialog" aria-hidden="false" tabIndex="0" >
                    {/* <div className="modal_header" data-modal-header=""> */}
                    {this.isReskin &&
                    <ModalTitle>                      
                        <div className="ResknModalHeader">Compare plans</div>
                    </ModalTitle>
                    }
                    {/* <div className="modal_content margin-top-zero padding-horiz-small  margin-bottom-small csrcart" data-modal-content="" style={{ maxHeight: '742.1px', height: '547px' }}> */}
                    <ModalBody>
                        <div className="row compare-header-row">
                            <div className={!this.isReskin ? "columns tiny-6 margin-bottom-medium" : "columns tiny-6 padding-vert-zero"}>
                                {!this.isReskin ? 
                                    <Title size="large" viewport={InHomeUtils.getdeviceType()} primitive="h6" color="black">Your Current Plan  &nbsp;&nbsp;&nbsp;&nbsp; {this.props?.profileCart?.cartHeader[0]?.monthlyRcPrice}/mo.</Title>
                                :
                                    <div className="reskinSubheading" >
                                        <div style={{marginBottom: "24px"}}>
                                            Your Current Plan
                                        </div>
                                        <div className="bold">
                                            {this.props?.profileCart?.cartHeader[0]?.monthlyRcPrice}/mo.
                                        </div>
                                    </div>
                                }
                                {/* <h6 className="margin-bottom-medium">Your Current Plan  &nbsp;&nbsp;&nbsp;&nbsp; {this.props?.profileCart?.cartHeader[0]?.monthlyRcPrice}/mo.</h6> */}
                                {/* <h6 className="margin-bottom-medium" id="priceOld">{this.props?.profileCart?.cartHeader[0]?.monthlyRcPrice}</h6> */}
                            </div>
                            <div className={!this.isReskin ? "columns tiny-6 margin-bottom-medium" : "columns tiny-6 padding-vert-zero"}>                                
                                {!this.isReskin ? 
                                    <Title size="large" viewport={InHomeUtils.getdeviceType()} primitive="h6" color="black">Your New Plan &nbsp;&nbsp;&nbsp;&nbsp; {this.props?.cart?.cartHeader[0]?.monthlyRcPrice}/mo.</Title>
                                :
                                    <div className="reskinSubheading padding-left-small">
                                        <div style={{marginBottom: "24px"}}>
                                            Your New Plan
                                        </div>
                                        <div className="bold">
                                            {this.props?.cart?.cartHeader[0]?.monthlyRcPrice}/mo.
                                        </div>
                                    </div>
                                }
                                {/* <h6 className="margin-bottom-medium">Your New Plan &nbsp;&nbsp;&nbsp;&nbsp; {this.props?.cart?.cartHeader[0]?.monthlyRcPrice}/mo.</h6> */}
                                {/* <h6 className="margin-bottom-medium" id="priceNew" >{this.props?.cart?.cartHeader[0]?.monthlyRcPrice}</h6> */}
                            </div>
                        </div>
                        <Line type="xLight" className="mm3-line-Reskin" />
                        <div className="modal-wrap">
                            <div className="">
                                <div className="">
                                    <div className="tiny-p-95 small-p-95 medium-p-100 right tiny-margin-vert-micro small-margin-vert-zero bg-white opened">
                                        <div className="medium-p-100" data-tabs-content-wrap="">
                                            <div id="resultcartold" className="">
                                                <div className="" id="CompareCartSection">
                                                    <div className="cart-tabs margin-bottom-large active" id="Month1" data-tabs-content="Month1">
                                                        {compareCartHeader}
                                                        <div className={!this.isReskin ? "margin-bottom-medium bold" : "margin-bottom-medium" }>Price include special offers.  Details are in your cart.</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* </div> */}
                    </ModalBody>
                </div>
            }
            </React.Fragment>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        lqState: state.loopQual,
        buildProductState: state.buildProduct,
        appState: state.app,
        cart: state.cart,
        router: state.router,
        saveState: state.save,
        profileCart: state.profileCart
    }
}

export default connect(
    mapStateToProps,
)(CompareCartData);